<template>
  <div id="loader-spacer">
    <div id="loader-container">
      <h2>
        <span class="material-icons-round">report_problem</span><br>
        Session Data not Found
      </h2>
      <button class="add-class" type="button" @click="returnPastSessions()">View Past Sessions</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoaderError",
  methods: {
    returnPastSessions(){
      this.$router.push({
        name: "past-sessions",
        params: { name: this.$route.params.name }
      });
    }
  }
};
</script>

<style lang="scss">
#loader-container {
  width: 100%;
  height: calc(100vh - 280px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 0;
  span {
    font-size: 2em;
  }
  h2 {
    text-align: center;
  }
}
</style>